'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';

// Detect iOS devices using modern APIs
const isIosDevice = typeof navigator !== 'undefined' && (/iPad|iPhone|iPod/.test(navigator.userAgent) || navigator.userAgent.includes('Mac') && navigator.maxTouchPoints > 1);
export const useBodyScrollLock = (lock, targetElement) => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== lock || $[1] !== targetElement) {
    t0 = () => {
      if (typeof document === "undefined") {
        return;
      }
      if (!lock || !targetElement) {
        return;
      }
      if (isIosDevice) {
        const {
          scrollY,
          scrollX
        } = window;
        const originalPosition = document.body.style.position;
        const originalTop = document.body.style.top;
        const originalLeft = document.body.style.left;
        document.body.style.position = "fixed";
        document.body.style.top = `${-scrollY}px`;
        document.body.style.left = `${-scrollX}px`;
        return () => {
          const y = -Number.parseInt(document.body.style.top, 10);
          const x = -Number.parseInt(document.body.style.left, 10);
          document.body.style.position = originalPosition;
          document.body.style.top = originalTop;
          document.body.style.left = originalLeft;
          typeof window !== "undefined" ? window?.scrollTo(x, y) : null;
        };
      }
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    };
    t1 = [lock, targetElement];
    $[0] = lock;
    $[1] = targetElement;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};